import BigPicture from 'bigpicture';

export default {
  install(Vue) {

    Vue.prototype.$bigPicture = BigPicture;
  },
};
